export default __webpack_public_path__ + "static/media/minus.a8fd2bc5.svg";